// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { colors } from '@peachjar/components';
import { every } from 'lodash';
import Icon from '@material-ui/core/Icon';

const { jungle, slate } = colors;

const styles = {
  root: {
    color: slate,
    '&$checked': {
      color: jungle,
    },
    width: '30px',
    height: '30px',
  },
  checked: {},
  label: {
    marginLeft: '0.5rem',
  },
};

type Props = {|
  +toggleCheckboxGroupComplete: boolean => void,
  +labels: string[],
  +CheckboxProps: Object,
  +classes: Object,
  +disabled: boolean,
  +isReadOnly: boolean,
  +uniqueIdModifier: string,
|};

type State = {|
  checkboxes: boolean[],
|};

class CheckboxGroup extends React.Component<Props, State> {
  static defaultProps;

  constructor(props) {
    super(props);

    this.state = {
      checkboxes: props.labels.map(() => false),
    };
  }

  handleChange = (i, toggleCheckboxGroupComplete) => async event => {
    const checkboxes = this.state.checkboxes.slice();
    checkboxes[i] = event.target.checked;
    await this.setState({ checkboxes });

    if (every(this.state.checkboxes, checkbox => checkbox === true)) {
      toggleCheckboxGroupComplete(true);
    } else {
      toggleCheckboxGroupComplete(false);
    }
  };

  render() {
    const {
      toggleCheckboxGroupComplete,
      labels,
      CheckboxProps,
      classes,
      disabled,
      isReadOnly,
      uniqueIdModifier,
    } = this.props;
    const { checkboxes } = this.state;

    return (
      <FormGroup>
        {labels.map((label, i) => (
          <FormControlLabel
            style={{ margin: 0 }}
            key={`${uniqueIdModifier}${i}`}
            classes={{
              label: classes.label,
            }}
            control={
              isReadOnly ? (
                <Icon>check</Icon>
              ) : (
                <Checkbox
                  inputProps={{
                    'data-testid': `field-${uniqueIdModifier}${i}`,
                  }}
                  checked={checkboxes[i]}
                  onChange={this.handleChange(i, toggleCheckboxGroupComplete)}
                  classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
                  disabled={disabled}
                  {...CheckboxProps}
                />
              )
            }
            label={labels[i]}
          />
        ))}
      </FormGroup>
    );
  }
}

CheckboxGroup.defaultProps = {
  toggleCheckboxGroupComplete: () =>
    console.log('Please add your own toggle function!'),
  labels: [],
  CheckboxProps: {},
  disabled: false,
  isReadOnly: false,
  uniqueIdModifier: 'checkbox',
};

export default withStyles(styles)(CheckboxGroup);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/confirm/components/CheckboxGroup.jsx